import {datadogLogs} from '@datadog/browser-logs';
import {datadogRum} from '@datadog/browser-rum';
import Package from '../../package.json';
import {LoggerInterface} from './logger-interface';

export type DatadogUser = {
  id: string;
  email?: string;
  name?: string;
};

const applicationId = process.env.REACT_APP_DATADOG_APPLICATION_ID;
const clientToken = process.env.REACT_APP_DATADOG_CLIENT_TOKEN;
const site = process.env.REACT_APP_DATADOG_SITE || 'us5.datadoghq.com';
const service = process.env.REACT_APP_DATADOG_SERVICE;
const env = process.env.REACT_APP_ENV;

export const isDatadogEnabled = (): boolean =>
  process.env.REACT_APP_DATADOG_ENABLED === 'true' && !!applicationId && !!clientToken && !!service;

export const initDatadog = (): void => {
  datadogRum.init({
    applicationId: applicationId as string,
    clientToken: clientToken as string,
    site,
    service,
    env,
    version: Package.version,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 0,
    defaultPrivacyLevel: 'mask-user-input',
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
  });
  datadogLogs.init({
    clientToken: clientToken as string,
    site,
    service,
    env,
    version: Package.version,
    sessionSampleRate: 100,
    forwardErrorsToLogs: true,
    forwardConsoleLogs: ['error'],
  });
};

export const setDatadogUser = (user: DatadogUser | null): void => {
  if (!isDatadogEnabled()) {
    return;
  }
  if (user) {
    datadogRum.setUser(user);
    datadogLogs.setUser(user);
  } else {
    datadogRum.clearUser();
    datadogLogs.clearUser();
  }
};

export const DatadogLogger: LoggerInterface = {
  log(msg: string): void {
    datadogLogs.logger.info(msg);
  },
  error(msg: string): void {
    datadogRum.addError(msg);
    datadogLogs.logger.error(msg);
  },
  debug(msg: string): void {
    datadogLogs.logger.debug(msg);
  },
  info(msg: string): void {
    datadogLogs.logger.info(msg);
  },
  warn(msg: string): void {
    datadogLogs.logger.warn(msg);
  },
};
